import {
  AtmBersama,
  BCA,
  BNI,
  BRI,
  CashPayment,
  CIMB,
  Danamon,
  Hana,
  Indodana,
  Mandiri,
  Paypal,
  Permata,
  Visa,
  Maybank,
  bcaVA,
  bniVA,
  mandiriVA,
  BankChina,
  Kredivo,
  Mastercard
} from "assets/images/icons/bank";

// GoldenFast Network Payment Methods - Based on payment.html
export const paymentListGFN = {
  // Virtual Account (Otomatis) - Section 1
  VAList: [
    {
      id: 1,
      label: "BCA VA",
      value: "bcava",
      icon: bcaVA,
      fee: 5000,
      category: "Virtual Account (Otomatis)"
    },
    {
      id: 2,
      label: "Mandiri VA", 
      value: "mandiriva",
      icon: mandiriVA,
      fee: 5000,
      category: "Virtual Account (Otomatis)"
    },
    {
      id: 3,
      label: "BRI VA",
      value: "briva", 
      icon: BRI,
      fee: 5000,
      category: "Virtual Account (Otomatis)"
    },
    {
      id: 4,
      label: "BNI VA",
      value: "bniva",
      icon: bniVA,
      fee: 5000,
      category: "Virtual Account (Otomatis)"
    },
    {
      id: 5,
      label: "ATM BERSAMA",
      value: "atmbersamava",
      icon: AtmBersama,
      fee: 5000,
      category: "Virtual Account (Otomatis)"
    },
    {
      id: 6,
      label: "MAYBANK VA",
      value: "biiva", // Sesuai dengan payment.html
      icon: Maybank,
      fee: 5000,
      category: "Virtual Account (Otomatis)"
    },
    {
      id: 7,
      label: "CIMB VA",
      value: "cimbva",
      icon: CIMB,
      fee: 5000,
      category: "Virtual Account (Otomatis)"
    },
    {
      id: 8,
      label: "PERMATA VA", 
      value: "permatabankva",
      icon: Permata,
      fee: 5000,
      category: "Virtual Account (Otomatis)"
    },
    {
      id: 9,
      label: "DANAMON VA",
      value: "danamonva",
      icon: Danamon,
      fee: 5000,
      category: "Virtual Account (Otomatis)"
    },
    {
      id: 10,
      label: "HANABANK VA",
      value: "hanabankva",
      icon: Hana,
      fee: 5000,
      category: "Virtual Account (Otomatis)"
    }
  ],

  // Bank Transfer (Manual) - Section 2
  transferBankList: [
    {
      id: 11,
      label: "BCA",
      value: "banktransfer", // Sesuai dengan payment.html
      icon: BCA,
      fee: 0, // Tidak ada fee di payment.html
      category: "Bank Transfer (Manual)"
    },
    {
      id: 12,
      label: "MANDIRI",
      value: "banktransfer3", // Menggunakan banktransfer3 untuk Mandiri
      icon: Mandiri,
      fee: 0,
      category: "Bank Transfer (Manual)"
    },
    {
      id: 13,
      label: "CHINA",
      value: "banktransfer2", 
      icon: BankChina,
      fee: 0,
      category: "Bank Transfer (Manual)"
    }
  ],

  // Kartu Kredit dan Lainnya (Otomatis) - Section 3
  creditCardList: [
    {
      id: 14,
      label: "MASTER CARD",
      value: "nicepaygateway",
      icon: Mastercard,
      fee: 0.031,
      add: 3000,
      feetype: "percent and fee",
      category: "Kartu Kredit dan Lainnya (Otomatis)"
    },
    {
      id: 15,
      label: "KREDIVO",
      value: "ipay88_kredivo",
      icon: Kredivo, 
      fee: 0.0235,
      feetype: "percent",
      category: "Kartu Kredit dan Lainnya (Otomatis)"
    },
    {
      id: 16,
      label: "PAYPAL",
      value: "paypal",
      icon: Paypal,
      fee: 0.06,
      add: 17000,
      feetype: "percent and fee",
      category: "Kartu Kredit dan Lainnya (Otomatis)"
    }
  ],

  // Additional Payment Methods - Section 4 (sesuai API valid options)
  additionalList: [
    {
      id: 17,
      label: "Cash Payment",
      value: "cashpayment",
      icon: CashPayment,
      fee: 0,
      category: "Pembayaran Tunai"
    },
    {
      id: 18,
      label: "Mail In",
      value: "mailin",
      icon: null,
      fee: 0,
      category: "Pembayaran via Pos"
    },
    {
      id: 19,
      label: "Doku Hosted",
      value: "dokuhosted",
      icon: null,
      fee: 0,
      category: "Payment Gateway"
    },
    {
      id: 20,
      label: "Xendit Credit Cards",
      value: "xendit_credit_cards",
      icon: null,
      fee: 0,
      category: "Kartu Kredit dan Lainnya (Otomatis)"
    },
    {
      id: 21,
      label: "Nicepay Gateway VA",
      value: "nicepaygatewayva",
      icon: null,
      fee: 0,
      category: "Virtual Account (Otomatis)"
    }
  ]
};

// Helper function to get all payment methods in a flat array
export const getAllPaymentMethodsGFN = () => {
  return [
    ...paymentListGFN.VAList,
    ...paymentListGFN.transferBankList,
    ...paymentListGFN.creditCardList,
    ...paymentListGFN.additionalList
  ];
};

// Helper function to get payment methods by category
export const getPaymentMethodsByCategory = (category) => {
  switch (category) {
    case 'va':
      return paymentListGFN.VAList;
    case 'transfer':
      return paymentListGFN.transferBankList;
    case 'credit':
      return paymentListGFN.creditCardList;
    case 'additional':
      return paymentListGFN.additionalList;
    default:
      return getAllPaymentMethodsGFN();
  }
};

// Helper function to find payment method by value
export const findPaymentMethodByValue = (value) => {
  const allMethods = getAllPaymentMethodsGFN();
  return allMethods.find(method => method.value === value);
};

// Export default for compatibility
export default paymentListGFN;